import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

export function useSearchMentionUsers(search: string) {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['searchMentionUsers', search],
    queryFn: () =>
      usersService.searchUsersForMention({ query: { search: search || '' } }),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao buscar usuários para menção',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      users: data,
      isLoading,
      refetch,
    }
  }

  return {
    users: [],
    isLoading,
    refetch,
  }
}
